import { render, staticRenderFns } from "./newPrivacyPolicy.vue?vue&type=template&id=4910edf4&scoped=true&"
import script from "./newPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./newPrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./newPrivacyPolicy.vue?vue&type=style&index=0&id=4910edf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4910edf4",
  null
  
)

export default component.exports